module.exports = __webpack_public_path__ + "static/media/Excell.97c9916f.svg";